app.controller('QuestionsCtrl', ['$scope', 'productData', 'autoSave', function($scope, productData, autoSave) {

}]);
